import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  subMenuContact2,
  subMenuContact3,
  subMenuContact4,
} from "../../../assets/images";
import axios from "axios";

const ContactItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [status, setStatus] = useState({
    type: "", // "success" | "error"
    message: "",
  });

  const [item, setItem] = useState([]);

  // 🔥 FORM STATE
  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    mobile: "",
    message: "",
  });

  const getLocalized = (field) => {
    if (!item) return "";
    return currentLanguage === "en"
      ? item[`${field}En`]
      : currentLanguage === "ru"
      ? item[`${field}Ru`]
      : item[field];
  };

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Settings`
      );
      setItem(response.data[0]);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  // 🚀 POST FUNCTION
  const handleSubmit = async () => {
    // simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.name || !form.company || !form.email || !form.mobile || !form.message) {
      setStatus({
        type: "error",
        message: "Zəhmət olmasa vacib sahələri doldurun",
      });
      return;
    } else if (!emailRegex.test(form.email)) {
      setStatus({
        type: "error",
        message: "Email düzgün deyil",
      });
      return;
    }

    try {
      await axios.post("https://cortex-site.runasp.net/api/Contacts", form);

      setStatus({
        type: "success",
        message: "Mesaj uğurla göndərildi!",
      });

      setForm({
        name: "",
        company: "",
        email: "",
        mobile: "",
        message: "",
      });

      // 3 saniyə sonra notification yox olsun
      setTimeout(() => setStatus({ type: "", message: "" }), 3000);
    } catch (error) {
      setStatus({
        type: "error",
        message: "Xəta baş verdi. Yenidən cəhd edin.",
      });
    }
  };

  return (
    <div className="pt-[56px] md:pt-[88px] bg-[#F9F9F9] font-secondFont">
      <div className="max-w-containerSm md:max-w-container mx-auto ">
        <div className="md:flex justify-between">
          <div className="md:w-[28%] text-[#1C1C1C]">
            <div className="space-y-4">
              <div>
                <div className="gap-2 flex">
                  <img alt="Location" className="h-6 w-6" src={subMenuContact2} />
                  <p className="text-[18px] font-medium">{t("Ünvan")}</p>
                </div>
                <p className="mt-2">{getLocalized("location")}</p>
              </div>

              <div>
                <div className="gap-2 flex mt-4">
                  <img alt="Email" className="h-6 w-6" src={subMenuContact3} />
                  <p className="text-[18px] font-medium ">{t("E-poçt")}</p>
                </div>
                <p className="mt-2">{item.email}</p>
              </div>

              <div>
                <div className="gap-2 flex mt-4">
                  <img alt="Mobile" className="h-6 w-6" src={subMenuContact4} />
                  <p className="text-[18px] font-medium">{t("Əlaqə nömrəsi")}</p>
                </div>
                <p className="mt-2">{item.mobile}</p>
              </div>
            </div>
          </div>

          <div className="md:w-[66%] mt-[56px] md:mt-0">
            <iframe
              src={item.map}
              style={{ width: "100%" }}
              height="257"
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* FORM */}
        <div className="mt-[64px] md:w-[845px] p-6 rounded-[16px] bg-white mx-auto">
          <p className="text-[#1C1C1C] text-[20px] font-medium mb-6">
            {t("Sizə Kömək Etməyə Hazırıq")}
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                required
                placeholder={t("Ad")}
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full p-3 border rounded-[8px]"
              />

              <input
                type="text"
                required
                placeholder={t("Şirkət")}
                value={form.company}
                onChange={(e) => setForm({ ...form, company: e.target.value })}
                className="w-full p-3 border rounded-[8px]"
              />

              <input
                type="email"
                required
                placeholder={t("E-poçt")}
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full p-3 border rounded-[8px]"
              />

              <input
                type="tel"
                required
                placeholder={t("Telefon")}
                value={form.mobile}
                onChange={(e) => setForm({ ...form, mobile: e.target.value })}
                className="w-full p-3 border rounded-[8px]"
              />
            </div>

            <textarea
              required
              rows="4"
              placeholder={t("Mesaj")}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full mt-4 p-3 border rounded-[8px]"
            />

            {/* INLINE NOTIFICATION */}
            {status.message && (
              <div
                className={`mb-4 p-3 rounded-[8px] text-sm font-medium ${
                  status.type === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {t(status.message)}
              </div>
            )}

            <div className="flex justify-center">
              <button
                type="submit"
                className="mt-4 px-6 py-3 bg-[#2a3d63] text-white rounded-[2px]"
              >
                {t("Göndər")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div> 
  );
};

export default ContactItems;